import React from 'react';

function About() {
  return (
    <>
      <section className="page-hero">
        <h1>About the Platform</h1>
        <p>Discover how AGRO-INVEST is transforming agricultural financing through AI and digital innovation.</p>
      </section>

      <div className="page-content">
        <div className="page-image">
          <img src="https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=800&q=80" alt="Agricultural fields" />
        </div>
        <h2>Who We Are</h2>
        <p>AGRO-INVEST is an AI-powered geospatial agricultural financing and investment platform designed to create a digital ecosystem that connects farmers, agricultural suppliers, investors, and platform administrators. We bridge the gap between traditional farming and modern fintech, enabling sustainable agricultural growth across communities.</p>

        <h2>What We Do</h2>
        <p>Our platform enables farmers to register digitally via WhatsApp, have their farms evaluated using AI risk scoring, receive input financing through verified suppliers, and attract funding from investors. We combine cutting-edge technology with deep agricultural expertise to make financing accessible, transparent, and impactful.</p>

        <h2>Our Approach</h2>
        <ul>
          <li><strong>Farmer-Centric:</strong> Simple WhatsApp-based onboarding and data collection</li>
          <li><strong>Data-Driven:</strong> AI risk engine for yield prediction and default probability</li>
          <li><strong>Supplier-Integrated:</strong> Digital voucher system for inputs and redemption tracking</li>
          <li><strong>Investor-Friendly:</strong> Transparent farm listings with risk ratings and expected returns</li>
        </ul>

        <h2>Contact</h2>
        <p>AGRO-INVEST is committed to leveraging technology for agricultural development. Contact us at +237 6 51 41 27 72.</p>
      </div>
    </>
  );
}

export default About;
